import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CategoryCardProps {
  name: string;
  color: string;
  image?: string;
  onClick?: () => void;
}
export function CategoryCard({
  name,
  color,
  image,
  onClick
}: CategoryCardProps) {
  return <button onClick={onClick} className={`relative overflow-hidden rounded-2xl aspect-[3/2] group transition-all duration-300 hover:scale-[1.02] hover:shadow-xl text-left ${color}`} data-id="element-91">
      {/* Content */}
      <div className="absolute inset-0 p-6 flex flex-col justify-between z-10" data-id="element-92">
        <h3 className="text-2xl font-bold text-white leading-tight drop-shadow-md" data-id="element-93">
          {name}
        </h3>
        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform translate-y-2 group-hover:translate-y-0" data-id="element-94">
          <span className="inline-flex items-center text-white font-medium text-sm bg-black/20 backdrop-blur-sm px-3 py-1 rounded-full" data-id="element-95">
            Explore <ArrowRight className="w-3 h-3 ml-1" data-id="element-96" />
          </span>
        </div>
      </div>

      {/* Image Overlay (Optional) */}
      {image && <div className="absolute right-0 bottom-0 w-2/3 h-full opacity-90 mix-blend-multiply transition-transform duration-500 group-hover:scale-110 origin-bottom-right" data-id="element-97">
          <img src={image} alt={name} className="w-full h-full object-cover object-center mask-image-gradient" data-id="element-98" />
        </div>}

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/10 to-transparent pointer-events-none" data-id="element-99" />
    </button>;
}